import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { filter, take } from "rxjs";

import { OrgFacade } from "state/org.facade";

export const orgResolver: ResolveFn<boolean> = () => {
  const orgFacade = inject(OrgFacade);

  return orgFacade.isOrgResolved$.pipe(
    filter((isOrgResolved) => isOrgResolved),
    take(1)
  );
};
